import http, { API_CORE } from '../../http';

export default function FavoriteServiceV2() {
  const getFavoritesIds = async () => {
    const response = await http(API_CORE).get('/v2/favorites/ids');
    return response.data;
  };

  const getFavorites = async (params) => {
    const response = await http(API_CORE).get('/v2/favorites', { params });
    return response.data;
  };

  const createFavorite = async ({ productVariantId }) => {
    const response = await http(API_CORE).post('/v2/favorites', { productVariantId });
    return response.data.favorite;
  };

  const deleteFavorite = async ({ favoriteId }) => {
    const response = await http(API_CORE).delete(`/v2/favorites/${favoriteId}`);
    return response.data;
  };

  return {
    getFavoritesIds,
    getFavorites,
    createFavorite,
    deleteFavorite,
  };
}
